import React from 'react'
import { useState } from 'react'
import GroupUnlink from './GroupUnlink'
import GroupLink from './GroupLink'

const GroupLinkUnlink = (props) => {
    const [ groupDetails, setGroupDetails ] = useState( JSON.parse( props[ 'data-group' ] ))

    return (
        <>
            { groupDetails?.ID ? (
                <GroupUnlink groupDetails={groupDetails} />
            ) : (
                <GroupLink groupDetails={groupDetails} />
            )}
        </>
    );
}

export default GroupLinkUnlink